export const SHOW_EXPORT = true;
export const SHOW_EXPORT_LANGUAGE = false;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/exportFlags.js